module.exports = __webpack_public_path__ + "static/media/whatsapp-logo.6e709ca4.webp";